import { render, staticRenderFns } from "./Guards.vue?vue&type=template&id=72ddbfe7&scoped=true&"
import script from "./Guards.vue?vue&type=script&lang=js&"
export * from "./Guards.vue?vue&type=script&lang=js&"
import style0 from "./Guards.vue?vue&type=style&index=0&id=72ddbfe7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ddbfe7",
  null
  
)

export default component.exports